import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography, Box } from '@mui/material';
import React from 'react';
import { memo } from "react";
import { ErrorIcon, ValidationWarningIcon, SuccessCheckIcon, DeleteConfirmationIcon, InfoCircleAlertIcon } from "../icons";
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CachedIcon from '@mui/icons-material/Cached';
import { useTranslation } from 'react-i18next';
import { getColors } from '../../Themes/default_color';
import { getContrastText } from '../../utils/commonUtilities';
export const POPUP_TYPE = {
    UNSAVED_DATA_WARNING: 'UNSAVED_DATA_WARNING',
    DELETE_CONFIRMATION_WARNING: 'DELETE_CONFIRMATION_WARNING',
    SUCCESS_ALERT: 'SUCCESS_ALERT',
    INFO_ALERT: 'INFO_ALERT',
    ERROR_ALERT: 'ERROR_ALERT',
    EVENT_NOT_ALLOWED: 'EVENT_NOT_ALLOWED',
    LOGOUT_WARNING: 'LOGOUT_WARNING',
    VALIDATION_WARNING: 'VALIDATION_WARNING',
    VALIDATION_CONFIRMATION_WARNING: 'VALIDATION_CONFIRMATION_WARNING',
    SUBMIT_CONFIRMATION: 'SUBMIT_CONFIRMATION',
    PDF_PREVIEW: 'PDF_PREVIEW',
    FILE_UPLOADS: 'FILE_UPLOADSPLOADS',
    RELOAD: 'RELOAD',
    CHECKLIST_UPLOAD_COMPLETE: 'CHECKLIST_UPLOAD_COMPLETE'
};
const IconWrapper = ({ children }) => (React.createElement(Box, { sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 1.5,
        '& .MuiSvgIcon-root': { fontSize: '32px' },
        '& svg': { width: 32, height: 32 },
    } }, children));
const ConfirmationAndInformationPoup = ({ popupType, uploadType, titleText, subTitleText, message, acceptBtnText, acceptCallBack, denyBtnText, denyCallBack, cancelCallBack, open, disableAcceptBtn, closePdf, pdfView, pdfUrl, onExited }) => {
    const [t] = useTranslation('global');
    const commonDialogProps = {
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        open,
        maxWidth: 'xs',
        fullWidth: true,
        PaperProps: { sx: { borderRadius: '20px', px: 1 } },
        TransitionProps: { onExited: () => onExited === null || onExited === void 0 ? void 0 : onExited() },
    };
    const commonTitleSx = { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', position: 'relative', pt: 3 };
    const commonTitleTextSx = { fontWeight: 700, fontSize: '20px', color: '#14151C', mt: 0.5 };
    const commonContentSx = { textAlign: 'center', pt: 1.5, pb: 1, px: 3 };
    const commonMessageSx = { fontSize: '15px', lineHeight: '22px', color: '#5B6472' };
    const commonActionsSx = { justifyContent: 'center', px: 3, pb: 4, pt: 2, gap: 2 };
    const colors = getColors();
    const commonCtaBtnSx = {
        flex: 1,
        minHeight: '48px',
        height: '48px',
        borderRadius: '999px',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '20px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
    };
    const primaryBtnSx = Object.assign(Object.assign({}, commonCtaBtnSx), { background: colors.Primary, color: getContrastText(colors.Primary), '&:hover': { background: colors.Primary } });
    const secondaryBtnSx = Object.assign(Object.assign({}, commonCtaBtnSx), { borderColor: colors.Primary, color: colors.Primary });
    switch (popupType) {
        case POPUP_TYPE.EVENT_NOT_ALLOWED:
        case POPUP_TYPE.ERROR_ALERT: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(ErrorIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.SUCCESS_ALERT: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(SuccessCheckIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.INFO_ALERT: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(InfoCircleAlertIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.DELETE_CONFIRMATION_WARNING: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconButton, { onClick: () => cancelCallBack && cancelCallBack(), size: "small", sx: { position: 'absolute', right: '8px', top: '10px' } },
                        React.createElement(CloseIcon, { fontSize: "small" })),
                    React.createElement(IconWrapper, null,
                        React.createElement(DeleteConfirmationIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'outlined', onClick: () => denyCallBack && denyCallBack(), sx: secondaryBtnSx }, denyBtnText),
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.VALIDATION_WARNING:
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(ValidationWarningIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), disabled: disableAcceptBtn, sx: primaryBtnSx }, acceptBtnText))));
        case POPUP_TYPE.UNSAVED_DATA_WARNING:
        case POPUP_TYPE.LOGOUT_WARNING:
        case POPUP_TYPE.VALIDATION_CONFIRMATION_WARNING:
        case POPUP_TYPE.SUBMIT_CONFIRMATION: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconButton, { onClick: () => cancelCallBack && cancelCallBack(), size: "small", sx: { position: 'absolute', right: '8px', top: '10px' } },
                        React.createElement(CloseIcon, { fontSize: "small" })),
                    React.createElement(IconWrapper, null,
                        React.createElement(ValidationWarningIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'outlined', onClick: () => denyCallBack && denyCallBack(), sx: secondaryBtnSx }, denyBtnText),
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), disabled: disableAcceptBtn, sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.PDF_PREVIEW: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow', sx: { '& .MuiPaper-root': {
                        minWidth: '60%',
                        '& .MuiDialogContent-root': {
                            padding: '0px !important'
                        },
                        '& .dialogue-title': {
                            paddingTop: '8px !important'
                        }
                    } } },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title' },
                    React.createElement(Box, { className: 'dialogue-text', display: 'flex', textAlign: 'center', justifyContent: 'space-between', alignItems: 'center', width: '100%' },
                        React.createElement(Box, { textAlign: 'center', width: '100%' },
                            React.createElement(Typography, null, titleText),
                            React.createElement(Typography, { fontSize: '12px !important' }, subTitleText)),
                        React.createElement(IconButton, { onClick: closePdf, className: 'close-icon' },
                            " ",
                            React.createElement(CloseIcon, null)))),
                React.createElement(DialogContent, { sx: { paddingBottom: '24px !important' } },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: { padding: '0px 24px',
                            '& iframe': {
                                height: "calc(100dvh - 126px)"
                            }
                        } },
                        React.createElement("iframe", { src: pdfUrl, title: t('GENERIC_STRINGS.SUCCESS_ALERT.pdfPreview'), width: "100%", style: { border: 'none' } })))));
        }
        case POPUP_TYPE.FILE_UPLOADS: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'fileUploadModal' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title', sx: { padding: '8px 12px !important' } },
                    React.createElement(Box, { className: 'dialogue-text', display: 'flex', textAlign: 'center', justifyContent: 'space-between', alignItems: 'center', width: '100%' },
                        React.createElement(Typography, null, titleText),
                        React.createElement(IconButton, { onClick: () => denyCallBack && denyCallBack(), className: 'close-icon' },
                            " ",
                            React.createElement(CloseIcon, null)))),
                React.createElement(DialogContent, { sx: { paddingBottom: '24px !important' } },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: { fontSize: '14px', color: '#3D3D42' } }, message)),
                React.createElement(DialogActions, null,
                    React.createElement(Typography, { fontSize: '12px', color: '#A3A9B9' },
                        t('PricingOption.Note'),
                        ": ",
                        t("CREATE_NOR_LOC_APP.FileUploads.SupportedFormats"),
                        " ",
                        uploadType == t('Dashboard.ApplicationStatus.Documents') ? t('CREATE_NOR_LOC_APP.FileUploads.SignedDocsNote') : ''),
                    React.createElement(Box, null,
                        React.createElement(Button, { variant: 'outlined', size: 'small', className: 'btn-txt btn-small', sx: secondaryBtnSx, onClick: () => denyCallBack && denyCallBack() }, denyBtnText),
                        React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', sx: primaryBtnSx, onClick: () => acceptCallBack && acceptCallBack(), disabled: disableAcceptBtn },
                            acceptBtnText,
                            "  ",
                            React.createElement(ArrowForwardIcon, null))))));
        }
        case POPUP_TYPE.RELOAD: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(CachedIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), sx: primaryBtnSx }, acceptBtnText))));
        }
        case POPUP_TYPE.CHECKLIST_UPLOAD_COMPLETE: {
            return (React.createElement(Dialog, Object.assign({}, commonDialogProps),
                React.createElement(DialogTitle, { id: "alert-dialog-title", sx: commonTitleSx },
                    React.createElement(IconWrapper, null,
                        React.createElement(SuccessCheckIcon, null)),
                    React.createElement(Typography, { sx: commonTitleTextSx }, titleText)),
                React.createElement(DialogContent, { sx: commonContentSx },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: commonMessageSx }, message)),
                React.createElement(DialogActions, { sx: commonActionsSx },
                    React.createElement(Button, { variant: 'outlined', onClick: () => denyCallBack && denyCallBack(), disabled: disableAcceptBtn, sx: secondaryBtnSx }, denyBtnText),
                    React.createElement(Button, { variant: 'contained', onClick: () => acceptCallBack && acceptCallBack(), disabled: disableAcceptBtn, sx: primaryBtnSx }, acceptBtnText))));
        }
        default: {
            return React.createElement(React.Fragment, null);
        }
    }
};
export default memo(ConfirmationAndInformationPoup);
